import { isNullable } from './isNullable';

const isNotNullable = <T>(value: T): value is NonNullable<T> => !isNullable(value);

export { isNotNullable };
